import { useState, useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, Switch } from 'react-router-dom';
import axios from 'axios';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { browserName, browserVersion } from "react-device-detect";

import Home from "./pages/Home";
import Team from "./pages/Team";
import Download from './pages/Download';
import Support from './pages/Support';

const  App = () => {
  const [downloadLink, setDownloadLink] = useState("https://app.vent.africa");

  useEffect(() => {
    const ua = navigator.userAgent;

    if (/android/i.test(ua)) {
      setDownloadLink("https://play.google.com/store/apps/details?id=com.vent.app");
    } // eslint-disable-next-line
    else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
      setDownloadLink("https://apps.apple.com/tt/app/vent-africa-crypto-to-cash/id1607187419");
    }
    else {
      setDownloadLink("https://app.vent.africa");
    }
  }, []);

  console.log(`${browserName} ${browserVersion}`);

  const notify = (msg) => toast(msg);

  const URL = "https://sd.vent.africa/api";

  const subscribeToNewsletters = async (email) => {
    const config = {
      headers: {
          "Content-Type": "application/json"
      },
    }

    const formData = {
      email: email,
      agent: `${browserName} ${browserVersion}`
    }

    try {
      const response = await axios.post(`${URL}/subscribe`, formData, config);
      notify(response.data.message);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <HelmetProvider>
      <Switch>
        <Route path="/" exact>
          <Home downloadLink={downloadLink} ToastContainer={ToastContainer} subscribeToNewsletters={subscribeToNewsletters} notify={notify} />
        </Route>

        <Route path="/team" exact>
          <Team ToastContainer={ToastContainer} subscribeToNewsletters={subscribeToNewsletters} notify={notify} />
        </Route>

        <Route path="/mobile" exact>
          <Download />
        </Route>
        <Route path="/m" exact>
          <Download />
        </Route>
        <Route path="/download" exact>
          <Download />
        </Route>
        <Route path="/dth" exact>
          <Download />
        </Route>
        <Route path="/support" exact>
          <Support />
        </Route>
      </Switch>
    </HelmetProvider>
  );
}

export default App;
